exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LessonCard-module__title___mbPi1{display:grid;grid-auto-flow:column;gap:.5rem;align-items:center;justify-content:start}.LessonCard-module__title___mbPi1 svg{transform:translateY(-1px);font-size:18px;color:#2addd0}.LessonCard-module__centered-button___1tif4{display:flex;justify-content:center}.LessonCard-module__centered-button___1tif4 label{pointer-events:all}.LessonCard-module__upload___1zwtl{display:none}.LessonCard-module__my-work___a1-2Y{font-size:14px;font-weight:700}.LessonCard-module__content___ho9ox{display:grid;gap:1.25rem}", ""]);

// exports
exports.locals = {
	"title": "LessonCard-module__title___mbPi1",
	"centered-button": "LessonCard-module__centered-button___1tif4",
	"upload": "LessonCard-module__upload___1zwtl",
	"my-work": "LessonCard-module__my-work___a1-2Y",
	"content": "LessonCard-module__content___ho9ox"
};